import React, { Component } from 'react';
import { Page, Block, Button } from 'framework7-react';

const style = {
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: 0,
  // backgroundImage: "linear-gradient(to bottom right, #DC1F1F, #B70000)",
  flexDirection: "column",
  overflow: "hidden",
}

const BtnParent = {
  position: "absolute",
  bottom: 0,
  width: "100%",
}

const Btn = {
  // color: "#000",
  // boxShadow: "0px 2px 11px #5d5959",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "30px auto",
  width: "40%",
  height: "50px",
  // borderRadius: "10px",
  // fontWeight: "500",
}

class Splash extends Component {
  reload() {
    window.location.reload()
  }

  render() {
    const { hasProblem, src } = this.props;

    return (
      <Page>
        <Block style={style} className="text-align-center">
          <img src={src} alt="logo" style={{ height: "100vh" }} />
          {hasProblem &&
            <div style={BtnParent}>
              <Button large fill style={Btn} onClick={this.reload}>
                {'تلاش دوباره'}
              </Button>
            </div>
          }
        </Block>
      </Page>
    )
  }
}

export default Splash